import React from "react";
import "./faq.css";

const Faq = () => (
  <div className="bodySec faqSec">
    <div className="container">
      <h2 className="text-center">
        <span>FAQ</span>
      </h2>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="dt-faq-panel termsofuseclass">
            <div className="text-bold">
              <span>
                1. What is DeepTrading.ai?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              DeepTrading.ai is a research platform that generates stock price predictions across multiple timeframes
              (from 1 day up to 12 months) for stocks. The goal is to help you explore predicted prices, compare them to outcomes
              over time, and evaluate simple rules-based strategies using the same predictions you see on the site.
            </p>

            <div className="text-bold">
              <span>
                2. What’s the difference between Basic and Advanced?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              <span className="text-italic">Basic</span> includes shorter horizons (Daily, Two-Day, Weekly).
              <span className="text-italic"> Advanced</span> includes all horizons (Daily, Two-Day, Weekly, Two-Week,
              Monthly, Two-Month, Three-Month, Six-Month, Yearly) and unlocks longer-term views and analysis.
            </p>
            <p className="text-justify marginParagraph">
              Pricing and plan details are always shown on the Pricing Plans page and may change over time.
            </p>
          
            <div className="text-bold">
              <span>
                3. Do you offer a free trial?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Yes. We offer a free trial (see the Pricing Plans page for current details). The trial lets you explore
              the product before purchasing a plan.
            </p>
          
            <div className="text-bold">
              <span>
                4. What is the “Deep Index” (DJI) on the home page?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              The Deep Index is a free, next-day prediction chart for the Dow Jones Industrial Average (DJI). It’s meant
              as an easy way to see how the system behaves over time without needing an account.
            </p>
          
            <div className="text-bold">
              <span>
                5. Which tickers do you cover?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              We focus on a curated list of stocks across multiple sectors, plus a small set of “anchor” tickers/indexes used
              for context. The list can change over time (for example, if a ticker is delisted or becomes non-tradeable).
            </p>

            <div className="text-bold">
              <span>
                6. What prediction timeframes (“horizons”) do you offer?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              DeepTrading.ai provides predictions over these horizons:
            </p>
            <ul>
              <li>Daily (1 day)</li>
              <li>Two-Day (2 days)</li>
              <li>Weekly (≈ 5 business days)</li>
              <li>Two-Week (≈ 10 business days)</li>
              <li>Monthly (≈ 21 business days)</li>
              <li>Two-Month (≈ 42 business days)</li>
              <li>Three-Month (≈ 63 business days)</li>
              <li>Six-Month (≈ 126 business days)</li>
              <li>Yearly (≈ 252 business days)</li>
            </ul>
            <p className="text-justify marginParagraph">
              The exact dates displayed are trading-day aligned (business-day based), not calendar-day based.
            </p>

            <div className="text-bold">
              <span>
                7. When are predictions updated?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Predictions are generated after market close. Because markets and data sources can have delays, the exact
              time you see refreshed results may vary slightly day to day.
            </p>

            <div className="text-bold">
              <span>
                8. What does “Prediction Date” mean?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Each horizon has a target date associated with it (for example, “Weekly Prediction Date”). That is the date
              the model is predicting the price for. Horizons are based on business days (trading days), not calendar days.
            </p>

            <div className="text-bold">
              <span>
                9. What’s the difference between Predicted Price, Predicted Return, and Predicted Gain/Loss %?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              These three values are connected, but they are displayed differently:
            </p>
            <p className="text-justify marginParagraph">
              <span className="text-italic">Predicted Price</span> is the model’s predicted close price for the target “Prediction Date” of
              a horizon (for example, the Weekly Prediction Date).
            </p>
            <p className="text-justify marginParagraph">
              <span className="text-italic">Predicted Return</span> is the predicted move expressed as a decimal return:
            </p>
            <p className="text-justify marginParagraph">
              <span className="text-italic">Predicted Return</span> = (Predicted Price / Close Price) − 1
            </p>
            <p className="text-justify marginParagraph">
              Example: <span className="text-italic">0.02</span> means +2% and <span className="text-italic">-0.05</span> means -5%.
            </p>
            <p className="text-justify marginParagraph">
              <span className="text-italic">Predicted Gain/Loss %</span> is the same idea shown as a percentage for easier scanning:
            </p>
            <p className="text-justify marginParagraph">
              <span className="text-italic">Predicted Gain/Loss %</span> = <span className="text-italic">Predicted Return</span> × 100
            </p>
            <p className="text-justify marginParagraph">
              Note: Predicted Return / Predicted Gain/Loss % are based on the prediction itself. They are not the same as a strategy backtest result,
              which uses realized outcomes to simulate how a rule would have performed historically.
            </p>

            <div className="text-bold">
              <span>
                10. How can I find stocks with the largest predicted move?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Use Data Search and sort by a horizon’s Predicted Return or Predicted Gain/Loss % column. This gives you a simple
              “screen” for the biggest predicted movers in that timeframe.
            </p>

            <div className="text-bold">
              <span>
                11. What accuracy metric do you show?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              The platform tracks accuracy per ticker and horizon over recent business-day windows. Our primary customer-facing metric is
              <span className="text-italic"> hybrid accuracy</span>, which rewards predictions that are directionally correct and/or
              close to the realized move (within a tolerance). This helps reflect the reality that “close enough” predictions can still be useful.
            </p>
            <p className="text-justify marginParagraph">
              You may also see accuracy shown over multiple windows (for example 10, 20, 30, and 40 business days), so you can understand how a ticker has behaved recently.
            </p>

            <div className="text-bold">
              <span>
                12. Why can accuracy vary so much by stock and timeframe?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Different stocks behave differently (volatility, sector regimes, macro sensitivity, and news impact). Longer horizons also
              compound uncertainty. That means accuracy will vary by ticker and by horizon, and can change over time as the market changes.
            </p>

            <div className="text-bold">
              <span>
                13. What is the “Trading Strategies” feature?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Trading Strategies lets you backtest a simple rule set on a single ticker using the same predictions you see elsewhere in the platform.
              You can choose the horizon to act on, how often to act (trade frequency in business days), what to do on positive vs negative predictions,
              and optional min/max predicted return filters.
            </p>

            <div className="text-bold">
              <span>
                14. What does “Trade Frequency (business days)” mean?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              It is the minimum number of business days between decisions. Examples: 1 = daily, 5 ≈ weekly, 21 ≈ monthly.
            </p>

            <div className="text-bold">
              <span>
                15. What do Minimum/Maximum Predicted Return mean?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              These are optional filters on the predicted return. If set, the prediction must be within the range to take action.
              Leaving a field blank means “no bound” on that side.
            </p>

            <div className="text-bold">
              <span>
                16. Can I save strategies and set one as Active?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Yes. You can save multiple strategies by name, load them later from the dropdown, and optionally mark one as your
              <span className="text-italic"> Active</span> strategy. If a strategy is Active, the platform can show the recommended action
              for the most recent market day for that strategy.
            </p>

            <div className="text-bold">
              <span>
                17. How does a backtest work?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Backtests are a research tool that simulate a simple decision rule using historical data. At each decision point, the strategy reads the model’s predicted return
              for the chosen horizon and takes an action (Buy / Sell / No Trade). The backtest then uses the realized move over that horizon to update the simulated equity curve.
            </p>
            <p className="text-justify marginParagraph">
              Backtests do not include commissions, slippage, taxes, or borrow costs. Results are for educational and research purposes only.
            </p>

            <div className="text-bold">
              <span>
                18. What is “BUY &amp; HOLD RETURN” in the Backtest Summary?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              BUY &amp; HOLD RETURN shows what the return would have been if you bought the stock at the start of the selected period and held it through the end.
              It provides a simple baseline to compare against the strategy’s Total Return.
            </p>

            <div className="text-bold">
              <span>
                19. Can I export data to CSV?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Yes. Use “Export to CSV” on Trading Strategies to download the Trades table, and use “Export to CSV” in Data Search to export search results.
            </p>

            <div className="text-bold">
              <span>
                20. Does DeepTrading.ai place trades for me?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              No. DeepTrading.ai is read-only and does not execute trades. Broker integrations are used for portfolio visibility only. Any decisions you make are your own.
            </p>

            <div className="text-bold">
              <span>
                21. Why do some predicted returns look very large?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Predicted returns are based on predicted price vs the entry day’s close price. In rare cases (high volatility, corporate actions, or unusual market moves),
              the implied % move can be large. Always sanity-check extreme values and consider using Trading Strategies to evaluate how similar signals behaved historically.
            </p>

            <div className="text-bold">
              <span>
                22. Do you offer an API?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Yes. If API access is enabled on your account, you can use a REST API with your personal API Key to retrieve predictions, run supported backtests, and access supported market-analysis endpoints.
              API usage is rate limited and designed for individual users.
            </p>

            <div className="text-bold">
              <span>
                23. What is the “Market Analysis” page?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Market Analysis includes a daily General Market Brief plus ticker-specific briefs with sentiment (Positive / Neutral / Negative).
              You can pick the date, sort the ticker list, and click any row to load the full ticker brief.
            </p>

            <div className="text-bold">
              <span>
                24. What is “Broker Portfolio”?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Broker Portfolio is a read-only view of connected brokerage holdings. It overlays supported DeepTrading.ai predictions
              (for example Close, Daily Prediction, Weekly Prediction, and Gain/Loss Prediction) so you can compare holdings with model output.
              Unsupported tickers are shown and can be flagged for support requests.
            </p>

            <div className="text-bold">
              <span>
                25. Can I get strategy action emails?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Yes. If you enable “Email me the suggested trading action” in Trading Strategies, the platform can send the active strategy’s suggested action to your profile email.
            </p>

            <div className="text-bold">
              <span>
                26. How do API credits work?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              API access uses credit packs. Different endpoints can consume different amounts (for example, backtests can scale by window size).
              If your credits run out, API requests are blocked until additional credits are purchased.
            </p>

            <div className="text-bold">
              <span>
                27. Do you update the model?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Yes. We continuously improve our data pipeline and model training to make predictions more robust and consistent over time. Updates are designed to preserve the
              core experience while improving stability and accuracy tracking.
            </p>

            <div className="text-bold">
              <span>
                28. Do you store my credit card information?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              No. Payments are handled by third-party payment processors; we do not store your full card details on our servers.
            </p>
	
            <div className="text-bold">
              <span>
                29. How do I cancel my subscription?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              You can manage or cancel your subscription from the Orders section in your dashboard. If you need help, email{" "}
              <a href="mailto:info@deeptrading.ai">info@deeptrading.ai</a>.
            </p>
	
            <div className="text-bold">
              <span>
                30. I forgot my password. What do I do?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Use the “Forgot Password” flow on the Log In page. You’ll receive an email with a link to reset your password.
            </p>
	
            <div className="text-bold">
              <span>
                31. Do I have to verify my email?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              We strongly recommend verifying your email so you can reliably receive important notifications (password resets, billing notices, and product updates).
              If you don’t see the email, check your spam folder and consider adding{" "}
              <a href="mailto:info@deeptrading.ai">info@deeptrading.ai</a> to your safe sender list.
            </p>
	
            <div className="text-bold">
              <span>
                32. Do you make manual adjustments to predictions?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              No. We do not manually adjust model predictions. We display the model outputs as generated.
            </p>
	
            <div className="text-bold">
              <span>
                33. Are you a financial advisor? Is this financial advice?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              No. DeepTrading.ai provides information for educational and research purposes only. We are not a broker-dealer or investment advisor.
              Trading and investing involve risk, and you can lose money.
            </p>
	
            <div className="text-bold">
              <span>
                34. How can I contact support?
              </span>
            </div>
            <p className="text-justify marginParagraph">
              Email us at <a href="mailto:info@deeptrading.ai">info@deeptrading.ai</a> and include your username and the ticker/date you were looking at.
              Screenshots help.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Faq;
